import { ComponentClass, FC } from "react";
import { useSelector } from "react-redux";
import { userRightsSelector } from "../redux/setting";
import { AccessEntries, PAGE_ACCESS } from "./accessEntries";
import { UserRight } from "../types/user";
import { translate } from "./translate";

export function withAccess(Component: FC | ComponentClass, entry: AccessEntries) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function WithAccess(props: any) {
    const accessRights: Record<AccessEntries, UserRight> = useSelector(userRightsSelector);
    const access = accessRights?.[entry];
    const level = access?.AccessLevel || PAGE_ACCESS.None;
    if (level === PAGE_ACCESS.None) {
      return <div className="access-denied">{translate("Access denied")}</div>;
    }
    return <Component {...props} access={access} />;
  };
}
